import { wrapReactRouterRouting } from '@sentry/react'
import { Routes } from 'react-router-dom'

const SentryRoutes = wrapReactRouterRouting(Routes)

export default SentryRoutes
